import PhoneInput from "../../../../../../../Components/PhoneInput"
import { defaultPhoneCountry } from "../../../utils/phoneRegion"

// Pre-select the country from the merchant's region until they pick one. Display-only:
// the default is never flushed, so an untouched optional phone stays empty while the
// dial code and flag still read sensibly.
const PhoneControl = ({ value, onChange, onTouch }) => {
  const hasCountry = value && value.name
  const phoneVal = hasCountry ? value : { ...(value || {}), ...(defaultPhoneCountry() || {}) }
  return (
    <PhoneInput
      value={phoneVal}
      onChange={(v) => {
        onTouch()
        onChange(v)
      }}
    />
  )
}

export default PhoneControl
